<template>
  <div
    :class="[
      selectedParentKeys && selectedParentKeys[0] && selectedParentKeys[0] === item[0].key ? 'check-tree' : 'init-tree',
      'tree-content',
      checkable ? 'multiple-table' : 'single-tree'
    ]"
    v-for="(item, index) in treeDataComputed"
    :key="index"
  >
    <a-tree
      v-bind="$attrs"
      v-model:selectedKeys="selectedKeys"
      v-model:checkedKeys="checkedKeys[index]"
      :showIcon="false"
      :checkable="checkable"
      :tree-data="item"
      @select="onSelect"
      @check="onCheck"
      :autoExpandParent="true"
    >
      <template #title="{ dataRef }">
        <div :class="[dataRef.class, dataRef.children && dataRef.children.length ? 'has-tree-child' : 'no-tree-child']">
          <slot name="title">
            {{ dataRef.title }}
          </slot>
        </div>
      </template>
    </a-tree>
  </div>
</template>
<script lang="ts" setup>
import type { TreeProps } from 'ant-design-vue'
import { ref, computed } from 'vue'
import type { PropType } from 'vue'
const props = defineProps({
  treeData: {
    type: Array as PropType<TreeProps['treeData']>,
    default: () => []
  },
  dataSource: {
    type: Array,
    default: () => []
  },
  searchData: {
    type: Object,
    default: () => {
      return {}
    }
  },
  checkable: {
    type: Boolean,
    default: true
  }
  // checkedKeys: {
  //   type: Array,
  //   default: () => []
  // }
})
// 拿到 props.checkedKeys 分割成数组
// watch(
//   props.checkedKeys,
//   () => {
//     console.log(2222)
//   },
//   {
//     deep: true,
//     immediate: true
//   }
// )
const selectedKeys = ref<string[]>([])
const checkedKeys = ref<string[]>([])
const selectedParentKeys = ref<string[]>([])
// 处理treeData 生成多个tree （仅为了做UI样式）
const treeDataComputed = computed(() => {
  const result: any = []
  props.treeData &&
    props.treeData.forEach((item) => {
      result.push([item])
    })
  return result
})
// 列选中
const onSelect = (selectedKey: [], e: { selected: boolean; selectedNodes: any; node: any; event: any }) => {
  let keys: string[] = []
  if (!selectedKey || !selectedKey.length) {
    selectedParentKeys.value = []
    return
  }
  if (e?.node?.parent?.nodes) {
    e.node.parent.nodes.forEach((item: any) => {
      keys.push(item.key)
    })
  } else {
    keys = selectedKey
  }
  selectedParentKeys.value = keys
}
// 复选框选中
const onCheck = (checkedKey: any, e: { checked: boolean; checkedNodes: any; node: any; event: any }) => {
  // 整合checkedKeys
  console.log(checkedKey, e)
}
</script>
<style lang="scss">
.check {
  position: absolute;
}
.top-radios {
  height: 40px;
  width: 40px;
  background: #1d4cd2;
  display: block;
}
.tree-content {
  padding-bottom: 8px;
  border-radius: 4px;
  position: relative;
  &::after {
    content: ' ';
    position: absolute;
    height: 1px;
    transform: scaleY(0.5);
    -webkit-transform: scaleY(0.5); /*兼容-webkit-引擎浏览器*/
    -moz-transform: scaleY(0.5);
    border-bottom: 1px solid #d8dfe4;
    right: 0;
    left: 12px;
    bottom: 8px;
  }
}
.ant-tree .ant-tree-treenode {
  width: 100%;
  padding: 0;
}
.ant-tree-treenode {
  height: 36px;
}
.ant-tree-treenode-selected {
  .active-tree-node {
    display: block;
  }
}
.active-tree-node {
  background-color: #1d4cd2;
  position: absolute;
  left: 4px;
  right: 4px;
  top: 1px;
  bottom: 2px;
  padding-left: 10px;
  color: #fff;
  display: none;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.check-tree {
  background: #f3f5f7;
  .ant-tree {
    background: transparent;
  }
}
.ant-tree-switcher,
.ant-tree-node-content-wrapper {
  height: 36px;
  line-height: 36px;
}
.ant-tree .ant-tree-node-content-wrapper {
  height: 36px;
  line-height: 36px;
  border-radius: 0;
  width: 100%;
}
.ant-tree-indent-unit {
  height: 100%;
}
.ant-tree-indent-unit-end,
.ant-tree-indent-unit-start {
  height: 100%;
}
.ant-tree-switcher-noop {
  display: none;
}
// 多选框
.ant-tree-checkbox {
  top: 13px;
  margin: 0;
  padding: 0 4px 0 4px;
}
.ant-tree-checkbox-inner {
  width: 14px;
  height: 14px;
}
// 画线
.no-tree-child,
.has-tree-child {
  &::after {
    content: ' ';
    position: absolute;
    height: 1px;
    right: 0;
    bottom: 0;
    transform: scaleY(0.5);
    -webkit-transform: scaleY(0.5); /*兼容-webkit-引擎浏览器*/
    -moz-transform: scaleY(0.5);
    border-bottom: 1px solid #d8dfe4;
  }
}
.multiple-table {
  .no-tree-child {
    &::after {
      left: -34px;
    }
  }
  .has-tree-child {
    &::after {
      content: ' ';
      left: -58px;
    }
  }
  .ant-tree .ant-tree-treenode:first-child {
    .has-tree-child {
      &::after {
        left: -46px;
      }
    }
  }
}
.single-tree {
  .no-tree-child {
    &::after {
      left: -12px;
    }
  }
  .has-tree-child {
    &::after {
      left: -36px;
    }
  }
  .ant-tree .ant-tree-treenode:first-child {
    .has-tree-child {
      &::after {
        left: -24px;
      }
    }
  }
}
.ant-tree-indent-unit-start,
.ant-tree-indent-unit {
  position: relative;
  &::after {
    content: ' ';
    position: absolute;
    height: 100%;
    width: 1px;
    left: 50%;
    top: 0;
    border-left: 1px solid #d8dfe4;
    transform: scaleX(0.5);
    -webkit-transform: scaleX(0.5); /*兼容-webkit-引擎浏览器*/
    -moz-transform: scaleX(0.5);
  }
}
// 选中样式
.ant-tree-treenode-selected {
  background: #1d4cd2;
  color: #fff;
  .ant-tree-indent {
    background: #f3f5f7;
    position: relative;
    &::before {
      content: ' ';
      background: url(http://10.81.5.105:10200/img/subtract.a5b882a8.svg);
      height: 4px;
      width: 4px;
      position: absolute;
      right: -4px;
    }
    &::after {
      content: ' ';
      background: url(http://10.81.5.105:10200/img/subtract.a5b882a8.svg);
      height: 4px;
      width: 4px;
      position: absolute;
      right: -4px;
      bottom: 0;
      transform: rotate(270deg);
    }
  }
}
.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background: transparent;
}
// hover
.ant-tree .ant-tree-node-content-wrapper {
  &:hover {
    background-color: transparent;
  }
}
</style>
